/* Predictive search: fetches the predictive-search section and injects grouped results. */
(() => {
  const form = document.querySelector('[data-predictive-search]');
  if (!form) return;

  const input = form.querySelector('input[type="search"]');
  const results = document.querySelector('[data-predictive-results]');
  const status = document.querySelector('[data-predictive-status]');
  const t = window.theme;
  let timer;
  let controller;

  const clear = () => {
    results.innerHTML = '';
    if (status) status.textContent = '';
  };

  const search = async (term) => {
    controller?.abort();
    controller = new AbortController();
    try {
      const url = `${t.routes.predictiveSearch}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[type]=product,page,article&resources[limit]=8`;
      const html = await (await fetch(url, { signal: controller.signal })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('predictive-search-results');
      if (!fresh) return clear();
      results.innerHTML = fresh.innerHTML;
      if (status) status.textContent = fresh.dataset.status;
    } catch (err) {
      if (err.name !== 'AbortError') clear();
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < 2) return clear();
    timer = setTimeout(() => search(term), 250);
  });

  document.getElementById('SearchDialog')?.addEventListener('close', () => {
    input.value = '';
    clear();
  });
})();
